// extracted by mini-css-extract-plugin
export var active = "RotatingMenu-module--active--5973b";
export var arrowContent = "RotatingMenu-module--arrowContent--b2f77";
export var container = "RotatingMenu-module--container--0cc8b";
export var description = "RotatingMenu-module--description--ef8e8";
export var item = "RotatingMenu-module--item--5b2b4";
export var itemContent = "RotatingMenu-module--itemContent--3cf0f";
export var polygonBox = "RotatingMenu-module--polygonBox--bad2f";